import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";

// Logo imports
import logoGrab      from "../assets/logos/1280px-Grab_application_logo.svg_-300x116.png";
import logoUnknown   from "../assets/logos/58481887cef1014c0b5e49a8-300x107.png";
import logoLivspace  from "../assets/logos/Livspace-logo-black-600x84.png";
import logoEllipsis  from "../assets/logos/ellipsis.png";
import logoEltripoy  from "../assets/logos/eltripoy.png";
import logoOnjuno    from "../assets/logos/onjuno.png";
import logoPolymorph from "../assets/logos/polymorph.png";
import logoSkyflow   from "../assets/logos/skyflow.png";
import logoSwiggy    from "../assets/logos/swiggy.png";
import logoTurbo     from "../assets/logos/turbo.png";
import logoUber      from "../assets/logos/uber.png";

const MONO = "'JetBrains Mono', 'Fira Code', ui-monospace, monospace";
const BG   = "#030014";
const LINE = "#1E2130";
const INK3 = "#7D8390";

const logos = [
  { src: logoGrab,      alt: "Grab" },
  { src: logoSwiggy,    alt: "Swiggy" },
  { src: logoUber,      alt: "Uber" },
  { src: logoSkyflow,   alt: "Skyflow" },
  { src: logoLivspace,  alt: "Livspace" },
  { src: logoPolymorph, alt: "Polymorph" },
  { src: logoOnjuno,    alt: "OnJuno" },
  { src: logoTurbo,     alt: "Turbo" },
  { src: logoEllipsis,  alt: "Ellipsis" },
  { src: logoEltripoy,  alt: "Eltripoy" },
  { src: logoUnknown,   alt: "Partner" },
];

const doubled = [...logos, ...logos];

const TrustedBy = () => (
  <Box sx={{ py: 5, background: BG, borderBottom: `1px solid ${LINE}`, overflow: "hidden" }}>
    <Container maxWidth="lg">
      <Typography sx={{
        textAlign: "center", fontFamily: MONO, fontSize: "12px",
        letterSpacing: "0.16em", textTransform: "uppercase",
        color: INK3, mb: 4,
      }}>
        Trusted by innovative teams worldwide
      </Typography>
    </Container>

    <Box sx={{
      position: "relative", overflow: "hidden",
      "&::before, &::after": {
        content: '""', position: "absolute", top: 0, bottom: 0,
        width: "120px", zIndex: 2, pointerEvents: "none",
      },
      "&::before": { left: 0, background: `linear-gradient(to right, ${BG} 0%, transparent 100%)` },
      "&::after":  { right: 0, background: `linear-gradient(to left, ${BG} 0%, transparent 100%)` },
    }}>
      <Box
        component={motion.div}
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 28, ease: "linear", repeat: Infinity }}
        sx={{ display: "flex", alignItems: "center", gap: 0, width: "fit-content" }}
      >
        {doubled.map((logo, i) => (
          <Box
            key={`${logo.alt}-${i}`}
            sx={{
              px: 4, py: 1.5,
              display: "flex", alignItems: "center", justifyContent: "center",
              flexShrink: 0,
              borderRight: `1px solid ${LINE}`,
            }}
          >
            <Box
              component="img"
              src={logo.src}
              alt={logo.alt}
              sx={{
                height: "28px",
                width: "auto",
                maxWidth: "120px",
                objectFit: "contain",
                filter: "brightness(0) invert(1)",
                opacity: 0.55,
                transition: "opacity 0.25s",
                "&:hover": { opacity: 0.9 },
                userSelect: "none",
                pointerEvents: "none",
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  </Box>
);

export default TrustedBy;
